module.exports = __webpack_public_path__ + "img/no_result_dog.c1955fe0.svg";